import React, { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react'
import { Spinner } from 'react-bootstrap'
import { useButtonClassName } from './useButtonClassName'

export type ButtonVariant =
  | 'primary'
  | 'primaryGhost'
  | 'secondary'
  | 'danger'
  | 'dangerGhost'
  | 'link'
  | 'dark'
  | 'darkLink'
  | 'darkGhost'
  | 'white'
  | 'header'
  | 'borderless'
  | 'lightPurple'
  | 'dashedButton'
  | 'grayGhost'
  | 'grayDarkGhostButton'
  | 'secondaryGhostButton'
  | 'cyanGhostButton'
  | 'borderlessGrayButton'
  | 'grayButton'
  | 'primaryLinkButton'

export interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  loading?: boolean
  variant?: ButtonVariant
}

export const Button: ForwardRefExoticComponent<PropsWithoutRef<ButtonProps> & RefAttributes<HTMLButtonElement>> = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ variant, className, loading, disabled, children, ...rest }, ref) => {
  return (
    <button ref={ref} className={useButtonClassName(variant, className)} disabled={loading || disabled} {...rest}>
      {loading ? <Spinner size='sm' /> : null}
      {children}
    </button>
  )
})
